/** Canonical public site origin (pretty URLs, without /new-iyaf prefix). */
export const SITE_ORIGIN = "https://iyafglobal.com";

/** Official mark-only logo (IYAF initials) — never recreate as favicon. */
export const FAVICON_PATH = "/assets/logos/iyaf-mark.png";
export const OG_IMAGE_PATH = "/assets/logos/iyaf-main.png";

export const HREFLANGS = ["en", "ar", "de", "es", "fr"];

export function publicAsset(path) {
  return `${process.env.PUBLIC_URL || ""}${path}`;
}

export function absoluteAssetUrl(path) {
  return `${SITE_ORIGIN}${publicAsset(path)}`;
}

const ROUTE_META_KEYS = {
  "/": { title: "home", description: "home" },
  "/about": { title: "about", description: "about" },
  "/model": { title: "model", description: "model" },
  "/impact": { title: "impact", description: "impact" },
  "/stories": { title: "stories", description: "stories" },
  "/engage": { title: "engage", description: "engage" },
  "/iyaf-hub": { title: "hub", description: "hub" },
  "/iyaf-social": { title: "social", description: "social" },
  "/iyaf-consult": { title: "consult", description: "consult" },
  "/iyaf-venture": { title: "venture", description: "venture" },
  "/open-opportunities": { title: "register", description: "register" },
  "/login": { title: "login", description: "login" },
  "/contact": { title: "contact", description: "contact" },
  "/profile": { title: "profile", description: "profile" },
  "/publications": { title: "publications", description: "publications" },
};

const FALLBACK_KEYS = { title: "notFound", description: "notFound" };

/** Pretty canonical path for SEO (no /new-iyaf prefix). */
export function canonicalPath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function canonicalUrl(pathname) {
  const path = canonicalPath(pathname);
  return path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
}

export function metaKeysForPath(pathname) {
  return ROUTE_META_KEYS[pathname] || FALLBACK_KEYS;
}

export function titleKeyForPath(pathname) {
  return `meta.titles.${metaKeysForPath(pathname).title}`;
}

export function descriptionKeyForPath(pathname) {
  return `meta.descriptions.${metaKeysForPath(pathname).description}`;
}

/** Routes used for sitemap generation and static HTML prerender. */
export const SEO_ROUTES = [
  { path: "/", key: "home" },
  { path: "/about", key: "about" },
  { path: "/model", key: "model" },
  { path: "/impact", key: "impact" },
  { path: "/stories", key: "stories" },
  { path: "/engage", key: "engage" },
  { path: "/iyaf-hub", key: "hub" },
  { path: "/iyaf-social", key: "social" },
  { path: "/iyaf-consult", key: "consult" },
  { path: "/iyaf-venture", key: "venture" },
  { path: "/open-opportunities", key: "register" },
  { path: "/contact", key: "contact" },
  { path: "/publications", key: "publications" },
  { path: "/profile", key: "profile" },
];
